export default __webpack_public_path__ + "static/media/overview1.8ab044c2.png";